import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export const ADMIN_COOKIE_KEY = 'zerde_admin_token';
export const USER_ROLE_KEY = 'zerde_user_role';
export const USER_ID_KEY = 'zerde_user_id';
export const USER_FULL_ACCESS_KEY = 'zerde_user_full_access';

export const useAdmin = (redirectTo?: string) => {
  const navigate = useNavigate();
  const isAdmin = !!Cookies.get(ADMIN_COOKIE_KEY);
  const userRole = Cookies.get(USER_ROLE_KEY) || '';
  const userId = Cookies.get(USER_ID_KEY) || '';
  const userFullAccess = parseInt(Cookies.get(USER_FULL_ACCESS_KEY) || '0', 10);

  useEffect(() => {
    if (redirectTo && !isAdmin) {
      navigate(redirectTo);
    }
  }, [isAdmin, navigate, redirectTo]);

  const logout = () => {
    Cookies.remove(ADMIN_COOKIE_KEY);
    Cookies.remove(USER_ROLE_KEY);
    Cookies.remove(USER_ID_KEY);
    Cookies.remove(USER_FULL_ACCESS_KEY);
    navigate('/');
  };

  return { isAdmin, logout, userRole, userId, userFullAccess };
}; 